import Lottie from 'react-lottie';
import { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';

import GeneratingSummary from './GeneratingSummary.json';
import OptimizingSections from './OptimizingSections.json';
import AssessingQuality from './AssessingQuality.json';
import CombiningSummaries from './CombiningSummaries.json';

import { useFeatureEntitlements } from '@frontegg/react';
import { SummaryStreamingInProgress } from './SummaryStreamingInProgress';

const LOADING_STEPS = {
  comprehensive: [
    {
      animationData: GeneratingSummary,
      alt: 'Generating summary',
      interval: 15000,
    },
    {
      animationData: OptimizingSections,
      alt: 'Optimizing sections',
      interval: 10000,
    },
    {
      animationData: AssessingQuality,
      alt: 'Assessing quality',
      interval: 10000,
    },
    {
      animationData: CombiningSummaries,
      alt: 'Combining summaries',
      showOnlyIfCombined: true,
      interval: 15000,
    },
  ],
  concise: [
    {
      animationData: GeneratingSummary,
      alt: 'Generating summary',
      interval: 15000,
    },
  ],
  balanced: [
    {
      animationData: GeneratingSummary,
      alt: 'Generating summary',
      interval: 15000,
    },
  ],
};

export const SummaryInProgress = ({
  interval = 10000,
  schedule_page = false,
  encounter_id = '',
  encounter_phase = 'in_visit',
  summary_verbosity = 'concise',
}) => {
  const [currentStep, setCurrentStep] = useState(0);
  const [isCombined, setIsCombined] = useState(false);
  const { getUuid } = useSelector((state) => state?.appointmentState);
  const { isEntitled: isStreamingSummaryEntitled } =
    useFeatureEntitlements('streaming-summary');

  useEffect(() => {
    if (schedule_page && encounter_phase == 'in-visit') {
      const textAreaValue = getUuid?.appointment_details
        ?.supervised_intake_summary
        ? getUuid?.appointment_details?.supervised_intake_summary
        : getUuid?.appointment_details?.llm_intake_summary
          ? getUuid?.appointment_details?.llm_intake_summary
          : '';
      setIsCombined(textAreaValue ? true : false);
    }
  }, [getUuid]);

  useEffect(() => {
    if (currentStep < filteredSteps.length - 1) {
      const currentInterval = filteredSteps[currentStep].interval || interval;
      const timer = setTimeout(() => {
        setCurrentStep((prev) => prev + 1);
      }, currentInterval);
      return () => clearTimeout(timer);
    }
  }, [currentStep, interval, isCombined]);

  const filteredSteps = (
    LOADING_STEPS[summary_verbosity] || LOADING_STEPS.concise
  ).filter(
    (step) =>
      !step.showOnlyIfCombined || (step.showOnlyIfCombined && isCombined)
  );

  return isStreamingSummaryEntitled ? (
    <SummaryStreamingInProgress
      encounter_id={encounter_id}
      encounter_phase={encounter_phase}
      schedule_page={schedule_page}
      summary_verbosity={summary_verbosity}
    />
  ) : (
    <div className="flex justify-center items-center min-h-[400px] w-full">
      <Lottie
        options={{
          loop: true,
          animationData: (filteredSteps[currentStep] || filteredSteps[0])
            .animationData,
          rendererSettings: {
            preserveAspectRatio: 'xMidYMid meet',
          },
        }}
        style={{ maxWidth: '80%', maxHeight: '80%' }}
      />
    </div>
  );
};
